
import "./code_block.css"



const CustomCodeBlock = ({code}) => {

    const lines = code.split("\n");


    return(
        <div>
            <pre
                style={{
                    backgroundColor: "#050B13",
                    padding: "10px",
                    borderRadius: "8px",
                    fontSize: "13px",
                    overflowX: "auto",
                    position: "relative", 

                    
                }}
                >
                {lines.map((line, i) => (
                    <div key={i} style={{ display: "flex",width:"100%" }}>
                    {/* Line number */}
                    <span
                        style={{
                        color:"#296BE2",
                        textAlign: "right",
                        paddingRight: "0px",                                    
                        userSelect: "none",
                        marginRight: "0px"
                        }}
                    >
                        {i + 1}
                    </span>

                    {<span
                    style={{left:"-35px",position: "absolute",
                    color:"#FFFFFF", whiteSpace: "pre", paddingRight: "0px",  
                    marginRight: "0px"}}
                    >{line}</span>}
                    </div>
                ))}
            </pre>
        </div>
    );
}

export default CustomCodeBlock;